import { Field, Formik } from "formik";
import SlotCalender from "../../../../Shared/SlotCalender/SlotCalender";
import "./EditSessions.scss";
import {
  API_RESPONSE,
  COMMON_CONSTANTS,
  CREATE_SESSIONS_FIELD,
  NUMBER_CONSTANTS,
  PERSONAL_INFORMATION,
  PROFESSIONAL_DETAILS,
  SESSIONS_ERROR_MESSAGE,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
  VALIDATION_CONSTANT,
} from "../../../../Utilities/Constants/Constants";
import * as yup from "yup";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { format } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { S3DataGetApi, nullUndefinedEmptyCheck, uploadFileToS3 } from "../../../../Services/Helpers/Helper";
import { useEffect, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import uploadImage from "../../../../../Assets/Registration/feather_upload-cloud-icon.svg";
import close from "../../../../../Assets/Sessions/close.svg";
import { REGISTRATION_ERRORS } from "../../../../Utilities/Constants/Validations";
import { toast } from "react-toastify";
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { MenuItem, Select } from "@mui/material";
import calenderImg from "../../../../../Assets/Sessions/calender.svg"
import moment from 'moment'
import { useNavigate, useParams } from "react-router-dom";
import pdfImage from "../../../../../Assets/global/pdf_icon.svg";
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from "../../../../Shared/ConfirmationDialog/ConfirmationDialog";
import { useSelector } from "react-redux";

const EditSessions = () => {
  const { id } = useParams();
  const uploadFileRef = useRef<HTMLInputElement | null>(null);
  const uploadFileBtnRef = useRef<HTMLInputElement | null>(null);
  const [currentUpload, setCurrentUpload] = useState("");
  const [syllabusFile, setSyllabusFile]: any = useState([]);
  const [viewerFile, setViewerFile] = useState("");
  const [fileViewerOpen, setFileViewerOpen] = useState(API_RESPONSE.FALSE);
  const [categoryList, setCategoryList]: any = useState([])
  const [slotData, setSlotData]: any = useState();
  const [formSubmitted, setFormSubmitted] = useState(API_RESPONSE.FALSE);
  const [category, setCategory]: any = useState([]);
  const [sessionDetail, setSessionDetail]: any = useState();
  const [oldSlots, setOldSlots]: any = useState([]);
  const dialogContent = SESSIONS_ERROR_MESSAGE.DELETE_MESSAGE;
  const [modalStatus, setmodalStatus] = useState(API_RESPONSE.FALSE);
  const [currentSlotIndex, setCurrentSlotIndex]: any = useState();
  const [sessionInitialValue, setSessionInitialValue]: any = useState(
    {
      [CREATE_SESSIONS_FIELD.SESSION_NAME]: "",
      [CREATE_SESSIONS_FIELD.CATEGORY]: "",
      [CREATE_SESSIONS_FIELD.PRICE_PER_HOUR]: "",
      [CREATE_SESSIONS_FIELD.SYLLABUS_FILE]: "",
      [CREATE_SESSIONS_FIELD.ADDITIONAL_NOTES]: "",
      [CREATE_SESSIONS_FIELD.COURSE_TYPE]: "",
    }
  )
  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });
  const navigate = useNavigate();


  useEffect(() => {
    getTutorCategory();
    getSessionDetail();
  }, [])

  /* yup validation schema */
  const sessionValidatinSchema: any = yup.object({
    [CREATE_SESSIONS_FIELD.SESSION_NAME]: yup
      .string()
      .required(SESSIONS_ERROR_MESSAGE.SESSION_NAME_REQUIRED),
    [CREATE_SESSIONS_FIELD.CATEGORY]: yup
      .string()
      .required(SESSIONS_ERROR_MESSAGE.CATEGORY_REQUIRED),
    [CREATE_SESSIONS_FIELD.COURSE_TYPE]: yup
      .string()
      .required(SESSIONS_ERROR_MESSAGE.COURSE_TYPE_REQUIRED),
    [CREATE_SESSIONS_FIELD.SYLLABUS_FILE]: yup
      .array(),
    // .required(SESSIONS_ERROR_MESSAGE.SYLLABUS_FILE_REQUIRED),
    [CREATE_SESSIONS_FIELD.ADDITIONAL_NOTES]: yup
      .string()
      .required(SESSIONS_ERROR_MESSAGE.ADDITIONAL_NOTES_REQUIRED),
  });

  /* Getting category list */
  const getTutorCategory = () => {
    axiosInstance.get(API_END_POINTS.TUTOR_CATEGORY).then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setCategoryList(response.data.result.data);
      }
    })
  };

  /* Session detail API call */
  const getSessionDetail = () => {
    axiosInstance.get(API_END_POINTS.SESSIONS_LIST + `?${STORAGE_KEYS.ID}=` + id).then(response => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setSessionDetail(response.data.result.data.data[NUMBER_CONSTANTS.ZERO])
        setInitialValue(response.data.result.data.data[NUMBER_CONSTANTS.ZERO]);

      }
    })
  };

  /* Setting Initial value */
  const setInitialValue = (data: any) => {
    setSessionInitialValue({
      [CREATE_SESSIONS_FIELD.SESSION_NAME]: data.session_title,
      [CREATE_SESSIONS_FIELD.CATEGORY]: data.category_name,
      [CREATE_SESSIONS_FIELD.COURSE_TYPE]: `${data.course_type}`,
      [CREATE_SESSIONS_FIELD.PRICE_PER_HOUR]: data.avg_fees_per_slot,
      [CREATE_SESSIONS_FIELD.SYLLABUS_FILE]: data.study_materials,
      [CREATE_SESSIONS_FIELD.ADDITIONAL_NOTES]: data.additional_notes,
    });
    setSyllabusFile(data.study_materials);
    setOldSlots(data.slots);
  }

  const handleBtnClick = () => {
    uploadFileBtnRef.current?.click();
  };

  /* Handling drag over */
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  /* Media upload function */
  const uploadFiles = async (file: any) => {
    const uploadedImage: any = await S3DataGetApi(file);
    setSyllabusFile([...syllabusFile, uploadedImage])

  };

  /* Checking upload type */
  const checkUploadType = (event: any, uploadingType: any) => {
    return new Promise((resolve, reject) => {
      const eventValue: any = uploadingType === PERSONAL_INFORMATION.DROP ? event.dataTransfer.files : event.target.files;
      const maxSize = NUMBER_CONSTANTS.TEN * NUMBER_CONSTANTS.THOUSAND_TWENTYFOUR * NUMBER_CONSTANTS.THOUSAND_TWENTYFOUR;
      if (syllabusFile.length + eventValue.length <= NUMBER_CONSTANTS.THREE && eventValue[0].size <= maxSize) {
        const isValid: any = [...eventValue].every((media: any) => {
          if (
            media.type.split('/')[NUMBER_CONSTANTS.ONE] === COMMON_CONSTANTS.PDF
          ) {
            return API_RESPONSE.TRUE;
          }
          return API_RESPONSE.FALSE
        });

        if (isValid) {
          resolve(API_RESPONSE.TRUE);
        } else {
          reject(REGISTRATION_ERRORS.PDF_FORMAT);
        }
      } else {
        syllabusFile.length + eventValue.length > NUMBER_CONSTANTS.THREE ?
          reject(REGISTRATION_ERRORS.SYLLABUS_LIMIT) :
          reject(REGISTRATION_ERRORS.UPLOADING_RESTRICTIONS)
      }
    })
  };


  /* Handling file drop */
  const handleDrop = (event: any) => {
    event.preventDefault();
    event.nativeEvent.preventDefault();
    checkUploadType(event, PERSONAL_INFORMATION.DROP).then(status => {
      uploadFiles(event);
    }).catch(error => {
      toast.error(error);
    });

  };

  /* Handling file change */
  const handleChange = (event: any) => {
    checkUploadType(event, PERSONAL_INFORMATION.SELECT).then(status => {
      uploadFiles(event);
    }).catch(error => {
      toast.error(error);
    });
  };

  /* Handling file drag */
  const handleDragEnter = (event: any) => {
    event.preventDefault();
  };

  /* Handling file drag leave */
  const handleDragLeave = (event: any) => {
    event.preventDefault();
  };
  /**Handle file viewer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(API_RESPONSE.FALSE);
    setViewerFile("");
  };

  /**Handle file viewer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(API_RESPONSE.TRUE);
  };


  /* Setting slot value from calender */
  const setSlotValues = (data: any) => {
    setSlotData(data);
  };

  /* Setting category object */
  const onSetCategory = (value: any) => {
    let data = categoryList.filter((item: any) => item.subject === value);
    setCategory(data);
  };

  /* Format time  */
  const formatDate = (time: any) => {
    return moment(time, 'HH:mm').format('h:mm A');
  }

  /* Delete files from syllabuslist */
  const handleDelete = (i: any) => () => {
    setSyllabusFile(
      syllabusFile.filter((item: any, index: any) => index !== i)
    );
  };


  /* Called once current slot index updated */
  useEffect(() => {
    if (nullUndefinedEmptyCheck(currentSlotIndex)) {
      setmodalStatus(API_RESPONSE.TRUE);
    };
  }, [currentSlotIndex])

  /* Setting reason dialog modal open */
  const onDeleteSlot = (i: any) => {
    setCurrentSlotIndex(i);

  }

  /* Delete slot API call */
  const onDelCategory = (data: any) => {
    setmodalStatus(API_RESPONSE.FALSE);
    setCurrentSlotIndex(null);
    let slotData = oldSlots[currentSlotIndex];
    if (data === API_RESPONSE.TRUE) {
      axiosInstance.delete(API_END_POINTS.SESSIONS_LIST +
        "?service_session_id=" + slotData.service_provider_id +
        "&teach_service_id=" + slotData.teach_service_provider +
        "&slot_id=" + slotData.id)
        .then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            toast.success(response.data.message, TOASTER_CONFIGS);
            getSessionDetail();
          }
        })
    }
  };

  const onCreateSession = (value: any) => {
    value.avg_fees_per_slot = value.pricePerHour;
    value.start_time = slotData ? moment(slotData.start, ["h:mm A"]).format("HH:mm") : '';
    value.end_time = slotData ? moment(slotData.end, ["h:mm A"]).format("HH:mm") : '';
    value.study_materials = syllabusFile;
    value.service_type = VALIDATION_CONSTANT.TUTOR;
    value.category = category[NUMBER_CONSTANTS.ZERO];
    value.slot_dates = {
      "date_ranges": slotData ? slotData.multiple : [],
      "single_date": slotData ? slotData.single : []
    }
    value.slot_price = value.pricePerHour;
    value.additional_notes = [value.additional_notes];
    value.service_provider_id = id;
    value.free_session = API_RESPONSE.FALSE;
    if (value.study_materials.length > 0) {
      axiosInstance.put(API_END_POINTS.UPDATE_SESSION, value).then(response => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          navigate(-1)
        }

      })
    }

  }


  return (
    <>
      <div className="edit_sessions_card_wrapper bi-wrapper pi-wrapper">
        <FileViewerDialog
          open={fileViewerOpen}
          handleClose={onFilerViewerDialogClose}
          viewerFile={viewerFile}
        ></FileViewerDialog>
        <ConfirmationDialog
          content={dialogContent}
          modalState={modalStatus}
          dialogStatus={onDelCategory}
        />
        <Formik
          initialValues={sessionInitialValue}
          validationSchema={sessionValidatinSchema}
          enableReinitialize={API_RESPONSE.TRUE}
          onSubmit={(values, actions) => {
            onCreateSession(values);
          }}
        >
          {(formik: any) => {
            return (
              <>
                <div className="create_sessions_card">
                  <div className="sessions_title"></div>
                  <div className="sessions_description"></div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">Session Name</label>
                        <Field
                          name={CREATE_SESSIONS_FIELD.SESSION_NAME}
                          className="email-input"
                          placeholder="Session Name"
                          disabled
                        />
                        <div className="errorMessage">
                          {formik.touched[CREATE_SESSIONS_FIELD.SESSION_NAME] &&
                            formik.errors[
                            CREATE_SESSIONS_FIELD.SESSION_NAME
                            ] && (
                              <p>

                                {
                                  formik.errors[
                                  CREATE_SESSIONS_FIELD.SESSION_NAME
                                  ]
                                }

                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">Category</label>
                        <Select
                          name={CREATE_SESSIONS_FIELD.CATEGORY}
                          placeholder="Select category"
                          className="email-input"
                          disabled
                          value={formik.values[CREATE_SESSIONS_FIELD.CATEGORY]}
                          onChange={(e) => {
                            onSetCategory(e.target.value);
                            formik.setFieldValue(
                              CREATE_SESSIONS_FIELD.CATEGORY,
                              e.target.value
                            );
                          }}

                        >
                          {categoryList.length > 0 && categoryList?.map((file: any) => {
                            return (

                              <MenuItem value={file.subject}>{file.subject}</MenuItem>

                            )
                          }
                          )}


                        </Select>
                        <div className="errorMessage">
                          {formik.touched[CREATE_SESSIONS_FIELD.CATEGORY] &&
                            formik.errors[CREATE_SESSIONS_FIELD.CATEGORY] && (
                              <p>

                                {formik.errors[CREATE_SESSIONS_FIELD.CATEGORY]}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">Price Per Hour</label>
                        <Field
                          name={CREATE_SESSIONS_FIELD.PRICE_PER_HOUR}
                          className="email-input"
                          placeholder="Price Per Hour"
                          disabled
                        />
                        <div className="errorMessage">
                          {formik.touched[
                            CREATE_SESSIONS_FIELD.PRICE_PER_HOUR
                          ] &&
                            formik.errors[
                            CREATE_SESSIONS_FIELD.PRICE_PER_HOUR
                            ] && (
                              <p>

                                {
                                  formik.errors[
                                  CREATE_SESSIONS_FIELD.PRICE_PER_HOUR
                                  ]
                                }

                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">Teaching Mode</label>
                        <Select
                          name={CREATE_SESSIONS_FIELD.COURSE_TYPE}
                          placeholder="Select category"
                          className="email-input"
                          disabled
                          value={formik.values[CREATE_SESSIONS_FIELD.COURSE_TYPE]}
                          onChange={(e) => {
                            onSetCategory(e.target.value);
                            formik.setFieldValue(
                              CREATE_SESSIONS_FIELD.COURSE_TYPE,
                              e.target.value
                            );
                          }}

                        >
                          <MenuItem value={'1'}>{"Online"}</MenuItem>
                          <MenuItem value={'2'}>{"On-premises"}</MenuItem>



                        </Select>
                        <div className="errorMessage">
                          {formik.touched[CREATE_SESSIONS_FIELD.COURSE_TYPE] &&
                            formik.errors[CREATE_SESSIONS_FIELD.COURSE_TYPE] && (
                              <p>

                                {formik.errors[CREATE_SESSIONS_FIELD.COURSE_TYPE]}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-12">
                      <div className="form-items" onDragOver={handleDragOver}
                        onDrop={(e: any) => {
                          handleDrop(e);
                          setCurrentUpload("emirates_front");
                        }}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        ref={uploadFileRef}>
                        <label className="form-label">
                          Syllabus covers file
                        </label>


                        <div className="syllabus-upload-file-wrapper"
                        >
                          <div className="upload-content">
                            <img src={uploadImage} alt="Learn and Play" />
                            <div className="text-content">
                              <p className="select-text">
                                Slecet a file or drag and drop here
                              </p>
                              <p className="file-text">
                                JPG,PNG filesize not more than 10MB
                              </p>
                            </div>

                          </div>
                          <input
                            type="file"
                            accept="application/pdf"
                            className="input-upload"
                            onChange={handleChange}
                            ref={uploadFileRef}
                          />
                          <input
                            type="file"
                            accept="application/pdf"
                            className="input-upload"
                            onChange={handleChange}
                            ref={uploadFileBtnRef}
                            style={{ display: "none" }}
                          />
                          <div className="select-btn-wrap">
                            <button
                              className="select-file-btn"
                              onClick={handleBtnClick}
                            >
                              SELECT FILE
                            </button>
                          </div>


                        </div>


                        <div className="errorMessage">
                          {formik.touched[
                            CREATE_SESSIONS_FIELD.SYLLABUS_FILE_REQUIRED
                          ] &&
                            formik.errors[
                            CREATE_SESSIONS_FIELD.SYLLABUS_FILE_REQUIRED
                            ] && (
                              <p>

                                {
                                  formik.errors[
                                  CREATE_SESSIONS_FIELD.SYLLABUS_FILE_REQUIRED
                                  ]
                                }

                              </p>
                            )}
                        </div>
                      </div>
                      {syllabusFile?.length > 0 && (
                        <div className="certificates-wrapper">
                          {syllabusFile?.map((file: any, index: any) =>

                            <div className="drive-image-wrapper">
                              <img className="drive-img" src={pdfImage} onClick={() => {
                                onFilerViewerDialogOpen(file);
                              }} />
                              <div className="close_icon_button">
                                <img
                                  src={close}
                                  alt="Learn and Play"
                                  className="close"
                                  onClick={handleDelete(index)}
                                />
                              </div>
                            </div>



                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {syllabusFile?.length === 0 && formSubmitted && <div className="errorMessage">
                    <p>{"Please upload syllabus cover file"}</p>
                  </div>}
                  <div className="row row-wrap">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="form-items">
                        <label className="form-label">Additional Notes</label>
                        <Field
                          as="textarea"
                          name={CREATE_SESSIONS_FIELD.ADDITIONAL_NOTES}
                          className="email-input input-textarea"
                          placeholder="Additional Notes"
                        />
                        <div className="errorMessage">
                          {formik.touched[
                            CREATE_SESSIONS_FIELD.ADDITIONAL_NOTES
                          ] &&
                            formik.errors[
                            CREATE_SESSIONS_FIELD.ADDITIONAL_NOTES
                            ] && (
                              <p>

                                {
                                  formik.errors[
                                  CREATE_SESSIONS_FIELD.ADDITIONAL_NOTES
                                  ]
                                }

                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-label mt-2">List of slot</div>
                  <div className="row slot-listing">
                    {
                      oldSlots?.map((slot: any, index: any) => {
                        return (
                          <div className="col-md-6">
                            <div className="slot_label_wrapper">
                              <div className="slot_list_wrapper">
                                <div className="details_card">
                                  <img className="calender-img" src={calenderImg} />
                                  <div className="slot_date_time">
                                    <div className="slot_date">
                                      {slot.start_date} - {slot.end_date}
                                    </div>
                                    <div className="time-mode-wrapper">
                                      <div className="slot_time">{formatDate(slot?.start_time)} to {formatDate(slot?.end_time)} </div>
                                      <div className="tutor_mode">{slotData?.course_type === `${1}` ? "Online" : "On-premises"}</div>
                                    </div>

                                  </div>
                                  {/* <div className="close_icon_button">
                            <img
                              src={close}
                              alt="Learn and Play"
                              className="close"
                              
                            />
                          </div>  */}
                                  <div >
                                    <DeleteIcon className="delete-icon" onClick={() => { onDeleteSlot(index); }} />
                                  </div>
                                </div>
                              </div>


                            </div>
                          </div>
                        )
                      })
                    }


                  </div>
                </div>

                <div className="slot_calender_list_container">
                  <div className="slot_calender_label_container">
                    <div className="slot_calender_label">Add Slot</div>
                    <SlotCalender setValue={setSlotValues}></SlotCalender>
                  </div>
                  {slotData && <div className="slot_list_label_wrapper">
                    <div className="slot_list_label">List of slot</div>
                    <div className="list-wrapper">
                      {
                        slotData?.totalRange.map((slot: any) => {
                          return (
                            <div className="slot_list_card_wrapper">
                              <div className="slot_details_card">
                                <img className="calender-img" src={calenderImg} />
                                <div className="slot_date_time">
                                  <div className="slot_date">
                                    {slot[0]} - {slot[1]}
                                  </div>
                                  <div className="time-mode-wrapper">
                                    <div className="slot_time">{slotData?.start} to {slotData?.end} </div>
                                    <div className="tutor_mode">{slotData?.course_type === `${1}` ? "Online" : "On-premises"}</div>
                                  </div>

                                </div>
                                {/* <div className="close_icon_button">
                            <img
                              src={close}
                              alt="Learn and Play"
                              className="close"
                            />
                          </div> */}
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>

                    {
                      !slotData &&
                      <div>
                        No Slots Available!
                      </div>
                    }

                  </div>}
                </div>
                <div className="session_actions_wrapper">
                  <button className="cancel_button">Cancel</button>
                  <button type="submit" className="add_session" onClick={() => {
                    formik.handleSubmit();
                    setFormSubmitted(API_RESPONSE.TRUE);
                  }} >
                    Add Session
                  </button>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </>
  )
};

export default EditSessions;